import { FinishSource, getAvailableFinishes } from 'utils/finishes';

/**
 * The Finish chip as a visibility filter (Asana 1219334446579337): a printing
 * shows when it exists in at least one accepted finish, read through
 * getAvailableFinishes (a null `finishes` is non-foil plus foil, never etched).
 * Foil shows printings with foil, Non-foil those with non-foil, a foil+non-foil
 * printing shows under both, and a Custom subset shows the union. An empty
 * list filters nothing: it is the "not filtering" state (edit mode before a
 * chip is touched).
 */
export const printingMatchesFinishFilter = (
  printing: FinishSource,
  accepted: readonly string[],
): boolean =>
  accepted.length === 0 || getAvailableFinishes(printing).some((finish) => accepted.includes(finish));

/**
 * The printings a save sends: selected AND visible under the current filters,
 * the same set the "N selected" count counts. A selected printing a filter
 * hides is not sent, and stays selected for when the filter is cleared.
 */
export const visibleSelectedPrintings = <T extends { id: number }>(
  printings: readonly T[],
  selected: ReadonlySet<number>,
  isVisible: (printing: T) => boolean,
): T[] => printings.filter((printing) => selected.has(printing.id) && isVisible(printing));
